<template>
  <section class="head">
    <div class="head-top">
      <div class="clearfix" style="max-width: 1377px;margin: 0px auto;">
        <a-row type="flex" justify="space-between">
          <div>
            <div class="logo"></div>
            <div class="menu">
              <ul>
                <!-- <li>
                  <a
                    href="/nocindex/index.html"
                    class="link-menu"
                    event-label="菜单_首页"
                    >首页</a
                  >
                </li> -->
                <!-- <li>
                  <a
                    @mouseover="showExtend = false"
                    href="/nocindex/index-noc.html"
                    class="link-menu"
                    event-label="菜单_诺客云"
                    >诺客云</a
                  >
                </li> -->
                <!-- <li>
                  <a
                    @mouseover="showExtend = true"
                    href="javascript:;"
                    class="link-menu"
                    id="menu_extendAndAuth"
                    event-label="菜单_认证及应用"
                    >认证及应用</a
                  >
                </li> -->
                <!-- <li style="position: relative;">
                  <a
                    @mouseover="showExtend = false"
                    href="/design"
                    target="_blank"
                    class="link-menu"
                    event-label="菜单_云地勘"
                    >云地勘<i class="iconfont icon-new"></i></a>
                </li> -->
                <!-- <li>
                  <a
                    @mouseover="showExtend = false"
                    href="/nocindex/scheme.html"
                    class="link-menu"
                    event-label="菜单_解决方案"
                    >解决方案</a
                  >
                </li> -->
                <li>
                  <a
                   @click="goHome"
                    class="link-menu"
                    event-label="菜单_帮助文档"
                    style="text-decoration: none;color: #2a82e5;border-bottom: 2px solid #4990e2;"
                    >Help Center</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="head-action">
            <span @click="eventHrefDemo"
              ><a
                href="/admin3/?clinet=web3_wiki&rewrite=off"
                class="link link-demo"
                event-label="菜单_访客体验"
                event-href-demo=""
                id="HrefDemo"
              >
                访客体验<i class="iconfont icon-hot2"></i></a
            ></span>
            <a
              href="/sso/login?service=https%3A%2F%2Fnoc.ruijie.com.cn%2Fadmin3%2F&action=register"
              class="btn-register"
              event-label="菜单_注册"
              event-href-register=""
            >
              注册
            </a>
            <a
              href="/sso/login?service=https%3A%2F%2Fnoc.ruijie.com.cn%2Fadmin3%2F"
              class="btn-login"
              event-label="菜单_登录控制台"
              event-href-login=""
            >
              登录控制台</a
            >
          </div> -->
        </a-row>
      </div>
    </div>
    <div
      @mouseover="showExtend = true"
      @mouseleave="showExtend = false"
      class="menu-extend animated"
      :style="{ display: showExtend ? 'block' : 'none' }"
    >
      <div class="warper clearfix">
        <a-row>
          <a-col :span="12">
            <dt class="title">认证组件</dt>
            <a-row type="flex" justify="space-around" class="text-center">
              <a-col :span="8">
                <a
                  href="/nocindex/index-mini-authsms.html"
                  event-label="菜单_短信认证"
                >
                  <div class="extend-box">
                    <div class="extend-icon icon-authsms"></div>
                    <div class="extend-name">短信认证</div>
                    <div class="extend-info"></div>
                  </div>
                </a>
              </a-col>
              <a-col :span="8">
                <a
                  href="/nocindex/index-mini-authwechat.html"
                  event-label="菜单_微信认证"
                >
                  <div class="extend-box">
                    <div class="extend-icon icon-authwechat"></div>
                    <div class="extend-name">微信认证</div>
                    <div class="extend-info"></div>
                  </div>
                </a>
              </a-col>
              <a-col :span="8">
                <a
                  href="/nocindex/index-mini-authppsk.html"
                  event-label="菜单_PPSK认证"
                >
                  <div class="extend-box">
                    <div class="extend-icon icon-authppsk"></div>
                    <div class="extend-name">PPSK认证</div>
                    <div class="extend-info"></div>
                  </div>
                </a>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="8">
            <dt class="title">最轻便的小程序应用</dt>
            <a-row type="flex" justify="space-around" class="text-center">
              <a-col :span="12">
                <a
                  href="/nocindex/index-mini-program.html"
                  event-label="菜单_小螺号"
                >
                  <div class="extend-box">
                    <div class="extend-icon icon-cxxiaoluohao"></div>
                    <div class="extend-name">小螺号</div>
                    <div class="extend-info"></div>
                  </div>
                </a>
              </a-col>
              <a-col :span="12">
                <a
                  href="/nocindex/index-mini-program-ppsk.html"
                  event-label="菜单_PPSK"
                >
                  <div class="extend-box">
                    <div class="extend-icon icon-cxppsk"></div>
                    <div class="extend-name">PPSK</div>
                    <div class="extend-info"></div>
                  </div>
                </a>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="4">
            <dt class="title" style="padding-left: 0px">支持云设备查询</dt>
            <div class="device-help-list">
              <a-row
                type="flex"
                justify="space-between"
                style="padding-top: 16px"
              >
                <div>AP设备</div>
                <div>
                  <a
                    href="https://noc.ruijie.com.cn/help/ArticleList?id=2edf1015cf92457a9fe215ff1ed0ca66"
                    event-label="菜单_下载_AP设备"
                    >查看</a
                  >
                </div>
              </a-row>
              <a-row
                type="flex"
                justify="space-between"
                style="padding-top: 16px"
              >
                <div>AC设备</div>
                <div>
                  <a
                    href="https://noc.ruijie.com.cn/help/ArticleList?id=16413560b46e46a1870684f3a44c7264"
                    event-label="菜单_下载_AC设备"
                    >查看</a
                  >
                </div>
              </a-row>
              <a-row
                type="flex"
                justify="space-between"
                style="padding-top: 16px"
              >
                <div>网关设备</div>
                <div>
                  <a
                    href="https://noc.ruijie.com.cn/help/ArticleList?id=7ab6c34e196f433c99079098ef82ae01"
                    event-label="菜单_下载_网关设备"
                    >查看</a
                  >
                </div>
              </a-row>
              <a-row
                type="flex"
                justify="space-between"
                style="padding-top: 16px"
              >
                <div>交换设备</div>
                <div>
                  <a
                    href="https://noc.ruijie.com.cn/help/ArticleList?id=0fd2196be6e9473588a7d8c9e3315cf6"
                    event-label="菜单_下载_交换设备"
                    >查看</a
                  >
                </div>
              </a-row>
              <a-row
                type="flex"
                justify="space-between"
                style="padding-top: 16px"
              >
                <div>认证组件</div>
                <div>
                  <a
                    href="https://noc.ruijie.com.cn/help/ArticleList?id=45ac3defdc1241fabaa03452697ca0e3"
                    event-label="菜单_下载_认证组件"
                    >查看</a
                  >
                </div>
              </a-row>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </section>
</template>

<script>
let setCookie = function(c_name, value, expiredays) {
  var exdate = new Date();
  exdate = exdate.getTime() + expiredays;
  exdate = new Date(exdate);
  document.cookie =
    c_name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString()) +
    ";path=/";
};
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },

  data() {
    return {
      showExtend: false,
      // baseUrl:'https://maccdemo.rj.link/'
      baseUrl: window.location.href.slice("help")[0],
      // baseUrl: process.env.VUE_APP_BASE_API,
      active: false,
    };
  },
  activated() {},
  methods: {
    goHome() {
      if (sessionStorage.getItem("isIsp") === "true") {
        if (this.$route.path !== '/isp') {
          this.$router.push("/isp");
        }
      } else {
        if (this.$route.path !== '/') {
          this.$router.push("/");
        }
      }
    },
    setActive() {
      this.active = false;
      if (this.$route) {
        console.log("this.$route", this.$route);
      }
    },
    eventHrefDemo() {
      setCookie("MACCDEMOCLINET", "web3", 3600 * 1000);
    },
    setHrefDemo() {
      let _a = document.getElementById("HrefDemo");
      var demoUlr = _a.getAttribute("href");
      var regArr = /service=(.*)&access_key/g.exec(demoUlr);
      if (regArr[1]) {
        var decodeUrl = decodeURIComponent(regArr[1]);
        if (decodeUrl.indexOf("?") == -1) {
          decodeUrl = decodeUrl + "?clinet=web3_help&rewrite=off";
        } else {
          decodeUrl = decodeUrl + "&clinet=web3_help&rewrite=off";
        }
        demoUlr = demoUlr.replace(regArr[1], encodeURIComponent(decodeUrl));
        console.log("_a", _a, demoUlr);
        _a.setAttribute("href", demoUlr);
        console.log("_a", _a, demoUlr);
      }
    },
  },
};
</script>
<style>
@import "../assets/main.css";
</style>
